import { h } from 'preact'
import PNFO from 'jlinc-shared/PNFO'

import classNames from 'lib/classNames'
import useDebouncedEffect from 'lib/useDebouncedEffect'
import { useAllOrganizations } from 'lib/membershipAppStateHooks'

import MyOrganizationsList from 'components/MyOrganizationsList'
import Button from 'components/Button'
import ErrorMessage from 'components/ErrorMessage'
import './index.sass'

// Super-admin only: every hub on the server, including non-publicly-listed ones
// the admin isn't a member of. Server-side search + "Load more" pagination.
export default function AllOrganizationsList({ className, searchQuery = '', ...props }){
  const {
    organizations,
    loadingAllOrganizations,
    loadingAllOrganizationsError,
    lastPageOfAllOrganizations,
    loadAllOrganizations,
    setAllOrganizationsSearchQuery,
  } = useAllOrganizations('AllOrganizationsList')

  // debounce the search box -> server-side search (resets the list to page 0)
  useDebouncedEffect(
    () => { setAllOrganizationsSearchQuery(searchQuery.trim()) },
    300,
    [searchQuery],
  )

  const listLoading = organizations === undefined && loadingAllOrganizations

  return <div className={classNames('AllOrganizationsList', { className })}>
    {loadingAllOrganizationsError &&
      <ErrorMessage error={loadingAllOrganizationsError} />}

    <MyOrganizationsList {...{
      ...props,
      sort: false,
      organizations,
      organizationsLoading: listLoading,
      onEmpty: `There are no ${PNFO.plural}`,
    }}/>

    {!listLoading && !lastPageOfAllOrganizations &&
      <div className="AllOrganizationsList-loadMore">
        <Button
          type="normal"
          onClick={() => loadAllOrganizations()}
          disabled={loadingAllOrganizations}
        >
          {loadingAllOrganizations ? 'Loading…' : `Load more ${PNFO.plural}`}
        </Button>
      </div>
    }
  </div>
}
